import React from 'react';

import Icon from 'components/Icon';

const DownloadIcon = ({ onClick, src, ...props }) => (
  <Icon download={src} icon="download" onClick={onClick} {...props} />
);

export default DownloadIcon;
